export const data = {
  footer: {
    header: 'is a Part of the CareGuide Family',
    mainItems: [
      {
        title: 'CanadianNanny.ca',
        url: 'canadiannanny.ca',
        color: '#a27bb7',
      },
      {
        title: 'Sitter.com',
        url: 'sitter.com',
        color: '#799900',
      },
      {
        title: 'HouseKeeper.com',
        url: 'housekeeper.com',
        color: '#dba900',
      },
      {
        title: 'PetSitter.com',
        url: 'petsitter.com',
        color: '#ff7f3f',
      },
      {
        title: 'ElderCare.com',
        url: 'eldercare.com',
        color: '#ff7f3f',
      },
      {
        title: 'HouseSitter.com',
        url: 'housesitter.com',
        color: '#00bfd5',
      },
      {
        title: 'ChildCareAdvantage.com',
        url: 'childcareadvantage.com',
        color: '#E65C83',
      },
      {
        title: 'Nanny Lane',
        url: 'nannylane.com',
        color: '#4B4E53',
      },
    ],
    secondaryItems: [
      {
        title: 'MeetAnAccountant.com',
        url: 'meetanaccountant.com',
      },
      {
        title: 'MeetACarpenter.com',
        url: 'meetacarpenter.com',
      },
      {
        title: 'MeetAChef.com',
        url: 'meetachef.com',
      },
      {
        title: 'MeetAnElectrician.com',
        url: 'MeetAnElectrician.com',
      },
      {
        title: 'MeetAGardener.com',
        url: 'MeetAgardener.com',
      },
      {
        title: 'MeetAHandyman.com',
        url: 'MeetAHandyman.com',
      },
      {
        title: 'MeetALandscaper.com',
        url: 'MeetAlandscaper.com',
      },
      {
        title: 'MeetAMechanic.com',
        url: 'MeetAmechanic.com',
      },
      {
        title: 'MeetAPainter.com',
        url: 'MeetApainter.com',
      },
      {
        title: 'MeetAPhotographer.com',
        url: 'MeetAphotographer.com',
      },
      {
        title: 'MeetAPlumber.com',
        url: 'MeetAplumber.com',
      },
      {
        title: 'MeetAProgrammer.com',
        url: 'MeetAprogrammer.com',
      },
      {
        title: 'MeetARenovator.com',
        url: 'MeetArenovator.com',
      },
      {
        title: 'MeetARoofer.com',
        url: 'MeetAroofer.com',
      },
      {
        title: 'MeetASalesman.com',
        url: 'MeetAsalesman.com',
      },
      {
        title: 'MeetASecurityguard.com',
        url: 'MeetAsecurityguard.com',
      },
      {
        title: 'MeetATruckdriver.com',
        url: 'MeetAtruckdriver.com',
      },
      {
        title: 'MeetATutor.com',
        url: 'MeetAtutor.com',
      },
      {
        title: 'MeetAvideographer.com',
        url: 'MeetAvideographer.com',
      },
      {
        title: 'MeetAWebdeveloper.com',
        url: 'MeetAwebdeveloper.com',
      },
      {
        title: 'MeetAWriter.com',
        url: 'MeetAwriter.com',
      },
    ],
  },
}
